export default __webpack_public_path__ + "static/media/cross.090813a7.svg";